import * as React from 'react';
import List from '@mui/material/List';
import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import CommentIcon from '@mui/icons-material/Comment';
import { useSelector } from 'react-redux';
import { IReduxState } from '../../../store';
import { IModule } from '../../../components/GestionFonctionnalite/Module/moduleSlice';

interface IAttribuerDroitProps {
    rightsChecked: IModule[];
    setRightsChecked: (x: IModule[]) => void;
}


export default function AttribuerDroit(props: IAttribuerDroitProps) {
    const { rightsChecked, setRightsChecked } = props
    const { modules } = useSelector((state: IReduxState) => state.module);



    const handleToggle = (value: IModule) => () => {
        const currentIndex = rightsChecked.indexOf(value);
        const newChecked = [...rightsChecked];
        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }
        setRightsChecked(newChecked);
    };

    return (
        <Box style={{ width: '100%', height: '40vh', overflow: "auto" }}>
            <List
                sx={{ width: '100%', bgcolor: 'background.paper' }}
                dense
            >
                {modules.map((value: IModule, index: number) => {
                    return (
                        <ListItem
                            key={index}
                        >
                            <ListItemButton onClick={handleToggle(value)} dense>
                                <Checkbox
                                    checked={rightsChecked.indexOf(value) !== -1}
                                    tabIndex={-1}
                                />
                                <ListItemText primary={`${value.libelleModule}`} />
                            </ListItemButton>
                        </ListItem>
                    );
                })}
            </List>
        </Box>
    );
}
